import ISO8601 from '@square/dashboard-data/models/squareup/bills/iso8601-date';
import TokenPair from '@square/dashboard-data/models/squareup/common/token/token-pair';
import { attr, ProtoBaseModel, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import Money from '@square/dashboard-money/models/money';
import { Itemization } from '@square/dashboard-protos/models/squareup/bills/cart';
import { PricingType } from '@square/dashboard-protos/models/squareup/items/items';
const {
  CreateReason
} = Itemization.FeatureDetails.InheritedItemizationDetails;
const {
  Type
} = Itemization.FeatureDetails.Seating.Destination;
const Intermission = ProtoBaseModel.extend({
  endOffset: attr(Number),
  startOffset: attr(Number)
});
const ResourceDetails = ProtoBaseModel.extend({
  name: attr(String),
  resourceToken: attr(String)
});
export const AppointmentsServiceDetails = ProtoBaseModel.extend({
  anyAvailableEmployee: attr(Boolean),
  intermissions: repeated(Intermission),
  noShowFeeMoney: attr(Money),
  // noShowFeePercentage hasn't been added to the Bills protos because carts are being deprecated.
  // See IAppointmentsServiceDetails in:
  // frontend/@square/dashboard-protos/addon/models/squareup/bills/cart.d.ts
  // frontend/@square/dashboard-protos/addon/models/squareup/client/bills/cart.d.ts
  noShowFeePercentage: attr(Number),
  ordinal: attr(Number),
  pricingType: attr(PricingType),
  resources: repeated(ResourceDetails),
  serviceDuration: attr(Number),
  serviceId: attr(String),
  transitionTimeDuration: attr(Number)
});
export const InheritedItemizationDetails = ProtoBaseModel.extend({
  createReason: attr(CreateReason),
  inheritedEventTokenPairs: repeated(TokenPair)
});
export const PricingEngineState = ProtoBaseModel.extend({
  blacklistedDiscountIds: repeated(String),
  blocklistedTaxIds: repeated(String, {
    defaultValue: []
  })
});
const Destination = ProtoBaseModel.extend({
  createdAt: attr(ISO8601),
  seatTokenPair: repeated(TokenPair),
  type: attr(Type)
});
export const Seating = ProtoBaseModel.extend({
  destination: attr(Destination)
});
const ItemizationFeatureDetails = ProtoBaseModel.extend({
  appointmentsServiceDetails: attr(AppointmentsServiceDetails),
  courseTokenPair: attr(TokenPair),
  inheritedItemizationDetails: attr(InheritedItemizationDetails),
  pricingEngineState: attr(PricingEngineState),
  seating: attr(Seating)
}).reopenClass({
  createDefault(options) {
    return this.create({
      pricingEngineState: PricingEngineState.create(),
      ...options
    });
  }
});
export default ItemizationFeatureDetails;